import { render } from "./MontlyDetails.vue?vue&type=template&id=98d4bf7a&scoped=true"
import script from "./MontlyDetails.vue?vue&type=script&lang=js"
export * from "./MontlyDetails.vue?vue&type=script&lang=js"

import "./MontlyDetails.vue?vue&type=style&index=0&id=98d4bf7a&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98d4bf7a"]])

export default __exports__